import { useTranslations } from 'next-intl';
import { GlowIcon, GlowTextBody, Icons } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ProductReview, ReviewPurchaserType } from '../../../../../server';

type ReviewPurchaserBadgeProps = {
    purchaserType: ProductReview['purchaserType'];
};

export const ReviewPurchaserBadge: Component<ReviewPurchaserBadgeProps> = ({ purchaserType }) => {
    const t = useTranslations('Discover.Pdp.ratingAndReviews');

    // FIXME: should be updated according to comment in ReviewPurchaserType.ts
    switch (purchaserType) {
        case ReviewPurchaserType.VERIFIED:
            return (
                <div className={'flex gap-0.5 items-center'}>
                    <GlowIcon Icon={Icons.Verified} type={'fullSize'} width={'1rem'} height={'1rem'} />
                    <GlowTextBody text={t('label.verifiedPurchaser')} />
                </div>
            );
        case ReviewPurchaserType.TESTER:
            return <GlowTextBody text={t('label.testerPurchaser')} />;
        case ReviewPurchaserType.SPONTANEOUS:
            return <GlowTextBody text={t('label.spontaneousPurchaser')} />;
        case ReviewPurchaserType.UNCONTROLLED:
            return <GlowTextBody text={t('label.uncontrolledPurchaser')} />;
    }
};
